import React from 'react';

type Tone = 'positive' | 'negative' | 'caution' | 'info' | 'neutral';

const tones: Record<Tone, string> = {
    positive: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
    negative: 'bg-rose-50 text-rose-700 ring-rose-200',
    caution: 'bg-amber-50 text-amber-700 ring-amber-200',
    info: 'bg-blue-50 text-blue-700 ring-blue-200',
    neutral: 'bg-slate-50 text-slate-600 ring-slate-200',
};

const base =
    'inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium ' +
    'ring-1 ring-inset whitespace-nowrap';

interface BadgeProps {
    tone?: Tone;
    /** Draws a small filled dot before the label. */
    dot?: boolean;
    children: React.ReactNode;
}

/** A quiet, outlined status chip. Reads more considered than a flat filled tag. */
export const Badge: React.FC<BadgeProps> = ({ tone = 'neutral', dot, children }) => (
    <span className={`${base} ${tones[tone]}`}>
        {dot && <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />}
        {children}
    </span>
);

interface StatusPillProps {
    on: boolean;
    onLabel: string;
    offLabel: string;
}

/** Boolean state as a dotted pill — green when on, red when off. */
const StatusPill: React.FC<StatusPillProps> = ({ on, onLabel, offLabel }) => (
    <Badge tone={on ? 'positive' : 'negative'} dot>
        {on ? onLabel : offLabel}
    </Badge>
);

export default StatusPill;
